import { Level } from './level';

export class Options {
    level: Level;
    restUrl: string;
}